// Método genérico para realizar peticiones
export const makeRequest = async (url, params) => {
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
};
